import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { Spacer, Button } from '@jisr-hr/design-system'
import classNames from 'classnames'
import I18n from 'translations/i18n'
import { TextInputField } from 'components/final-form'
import { required } from 'components/global/form/FormValidations'
import { labels } from 'utils/whitelabel'

const SlugFrom = ({ onSubmit, fetching }) => (
  <Form onSubmit={onSubmit}>
    {({ handleSubmit, submitting }) => (
      <form
        onSubmit={handleSubmit}
        className="login-form"
      >
        <TextInputField
          testId="login-slug"
          name="slug"
          label={I18n.t('slug')}
          validate={required}
        />
        <Spacer height="10px" />
        <Button
          disabled={fetching || submitting}
          label={I18n.t('submit')}
          onClick={handleSubmit}
          type="submit"
          className={classNames(
            'login-btn-full',
            labels.name === 'Maken' && 'maken-btn',
            labels.name === 'Ahad' && 'ahad-btn',
          )}
        />
      </form>
    )}
  </Form>
)

SlugFrom.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
}

export default SlugFrom
